import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { GlobalModule } from 'src/app/global.module';
import { DonationRowComponent } from './donation-row/donation-row.component';
import { DialogImportDonationsComponent } from './dialog-import-donations/dialog-import-donations.component';
import { ActionCardComponent } from './action-card/action-card.component';

@NgModule({
    declarations: [DashboardComponent, DonationRowComponent, DialogImportDonationsComponent, ActionCardComponent],
    imports: [CommonModule, GlobalModule, DashboardRoutingModule],
})
export class DashboardModule {}
